import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { deleteReview } from '../../redux/Slices/ReviewsSlice';
import notify from '../UseNotification';

const UseDeleteReview = (item) => {
    const dispatch = useDispatch()
    let reviewUserId = item.user._id;
    const [DeleteShow, setDeleteShow] = useState(false)
    const [loading, setLoading] = useState(true)
    const { DeleteReview } = useSelector(state => state.ReviewsReducer)

    // handle popup close
    const handleDeleteClose = () => {
        setDeleteShow(false)
    }

    // handle show popup
    const handleDeleteShow = () => {
        setDeleteShow(true)
    }

    // handle delete review function
    const handleDeleteReview = async () => {
        setLoading(true)
        await dispatch(deleteReview(item._id))
        handleDeleteClose()
        setLoading(false)
    }

    // handle the delete review request response
    useEffect(() => {
        if (loading === false) {
            if (DeleteReview.status === 204) {
                notify("the review is deleted", "success")
                setTimeout(() => {
                    window.location.reload(false)
                }, 1500)
            } else {
                notify("Try again to delete the review", "error")
            }
        }
    }, [loading])

    
    return [reviewUserId, DeleteShow, handleDeleteClose, handleDeleteShow, handleDeleteReview]
}

export default UseDeleteReview
